import React, { JSX } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Define the component's expected props
interface SessionAlertModalProps {
  open: boolean;
  remainingSeconds: number | null; // Use number | null to match hook's return
  onStay: () => void;
  onLogout: () => void;
}

export default function SessionAlertModal({ open, remainingSeconds, onStay, onLogout }: SessionAlertModalProps): JSX.Element {
  
  const handleStay = (): void => {
    onStay();
  };

  const handleLogOff = (): void => {
    onLogout();
  };

  // Guard against null/0 in case of rendering delay, though 'open' should handle this
  const displayRemaining = remainingSeconds ?? 0;

  return (
    <Dialog
      open={open}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      disableEscapeKeyDown
      onClose={(event, reason) => {
        // If the user tries to click outside/use escape, treat it as "Stay In" by default
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          handleStay();
        }
      }}
    >
      <DialogTitle id="logout-dialog-title">
        Session Timeout Alert 🚨
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          Your session is about to expire! 
          Do you want to stay logged in?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogOff} color="error" variant="outlined">
          Log Off
        </Button>
        <Button onClick={handleStay} color="primary" variant="contained" autoFocus>
          {remainingSeconds? `Stay Logged In (${remainingSeconds})` : "Stay Logged In"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}